import { createApiCall } from 'lib/base';

const CREATE_STAFF_USER_ASSIGNMENT =
  'CREATE_STAFF_USER_ASSIGNMENT';

const apiCall = createApiCall<{ payload: any }>(
  CREATE_STAFF_USER_ASSIGNMENT,
  ({ payload }) => ({
    endpoint: `/api/admin/wealth/user-assignments`,
    method: 'POST',
    body: payload,
  })
);

export default apiCall;
